module.exports = __webpack_public_path__ + "static/media/dylan.1ee8ce83.png";